import { render, staticRenderFns } from "./成交公告.vue?vue&type=template&id=22fd0609&scoped=true"
import script from "./成交公告.vue?vue&type=script&lang=js"
export * from "./成交公告.vue?vue&type=script&lang=js"
import style0 from "./成交公告.vue?vue&type=style&index=0&id=22fd0609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd0609",
  null
  
)

export default component.exports